module.exports = __webpack_public_path__ + "static/media/workano-dark-en.a32f0688.svg";